import { RouteProp, useNavigation, useRoute } from '../../../navigation/native';
import { FormikProps } from 'formik';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { RootStackParamList } from '../../../app/Navigation';
import { Snippet, SnippetDataDictionary } from '../../../services/dataModels';
import {
  editingActions,
  selectEditedSnippets,
  selectFormState,
  selectShiftLogDetails,
} from '../../../store';
import { AppDispatch } from '../../../store/store';
import { findGroupSnippet } from '../helpers';
import Layout from '../Layout';
import SaveButton from '../SaveButton';
import Header from './Header';
import SnippetForm from './SnippetForm';

const RowListScreen = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { params } = useRoute<RouteProp<RootStackParamList, 'EditingRowListScreen'>>();

  const shiftLogDetails = selectShiftLogDetails.useHook();
  const formState = selectFormState.useHook();
  const editedSnippet = selectEditedSnippets.useHook();

  const formikRef = useRef<FormikProps<Snippet>>(null);

  const [, snippet] = findGroupSnippet(params, shiftLogDetails.snippets);
  const hasSaveButton =
    snippet.type !== 'Task' &&
    snippet.type !== 'StandingOrder' &&
    snippet.type !== 'Monitoring' &&
    snippet.type !== 'Instruction';

  const selectRowData = (s: Snippet): [string, SnippetDataDictionary[]] => {
    return [`data[${params.rollupIndex ?? 0}]`, s.data[params.rollupIndex ?? 0].rowData];
  };

  return (
    <Layout
      title={params.lastLink}
      header={<Header snippet={snippet} rollupIndex={params.rollupIndex} />}
      onBackPressed={() => {
        formikRef.current.resetForm();
      }}
      action={
        hasSaveButton &&
        formState.dirty && (
          <SaveButton
            snippet={() => formikRef.current.values}
            onSuccess={() => formikRef.current.resetForm({ values: formikRef.current.values })}
            disable={!formState.valid}
          />
        )
      }
      content={
        <SnippetForm
          ref={formikRef}
          snippet={editedSnippet}
          selectRowData={selectRowData}
          state={{
            get: formState,
            set: (v) => dispatch(editingActions.formStateChanged(v)),
          }}
        />
      }
    />
  );
};

export default RowListScreen;
